import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";

const Anchor = styled.span`
  background: #204354;
  border-radius: 0.5rem;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 0.6rem;
  font-weight: bold;
  height: 1rem;
  line-height: 1rem;
  margin-left: 0.2rem;
  position: relative;
  text-align: center;
  top: -0.2rem;
  vertical-align: baseline;
  width: 1rem;
`;

const Tooltip = ({ id, children }) => (
  <Anchor data-tip data-for={id}>
    <ReactTooltip
      id={id}
      textColor="#204354"
      backgroundColor="#fff"
      border
      borderColor="#d8d8d8"
      className="inline-tooltip"
    >
      {children}
    </ReactTooltip>
    ?
  </Anchor>
);

export default Tooltip;